(() => {
  document.querySelectorAll('[data-currency-selector]').forEach(selector => {
    selector.addEventListener('change', e => {
      selector.closest('form').submit();
    });
  });
})();